React = require 'react'
t = require('views/internal/recup-with-helpers')('org_account')
l = require 'lib/localize'

module.exports = class extends React.Component
  displayName: 'VisibilityContentsComponent'

  render: t.renderable ->
    { canChange, visibility } = @props

    t.div ->
      t.div ->
        helperText = l(['org perms', visibility, 'text'])

        switch visibility
          when 'public'
            t.p ->
              t.icon 'public'
              t.format 'public-helpertext', { helperText }
          when 'private'
            t.p ->
              t.icon 'private'
              t.format 'private-helpertext', { helperText }
          else
            throw new Error("Unrecognized visibility setting: #{ visibility }")

      if !canChange
        t.p '.helper.u-float-left', ->
          t.format 'you-need-to-be-an-admin-to-change-this-setting'



// WEBPACK FOOTER //
// ./app/scripts/views/organization/visibility-component.coffee